import * as types from './types'
import storage from '@/plugins/storage'
export default () => ({
  more: '',
  pageSize: storage.local.getItem(types.CHAT_PAGE_SIZE) || 10,
  searchTerm: storage.session.getItem(types.CHAT_SEARCH_TERM) || '',
  sortDir: storage.session.getItem(types.CHAT_SORT_DIR) || 'desc',
  orderBy: storage.session.getItem(types.CHAT_ORDER_BY) || 'calibrateEvent',
  filterBy: parseInt(storage.local.getItem(types.CHAT_FILTER_BY)) || null,
  defaultChatGroup: {
    chat: null,
    firm: null,
    chatName: '',
    startOfDay: '08:00',
    endOfDay: '17:00',
    slots: 0,
    avgSlotTime: 0,
    blocks: []
  },
  isChecked: false,
  channels: [],
  channel: null,
  currentChannel: null,
  messages: [],
  foundMembers: [],
  removedMembers: [],
  report: null,
  users: [],
  moreUsers: '',
  userChannelCount: 0,
  isAllChecked: false
})



// WEBPACK FOOTER //
// ./src/store/modules/chatadmin/state.js